import AppRoutes from '@/routes';
import { AuraProvider, AuthProvider, NotificationProvider, ThemeProvider } from '@/common/context';
import { ConfirmProvider } from './pages/ui/base/ConfirmProvider';

//import { configureFakeBackend } from './common';

// For Modern demo import Modern.scss
import './assets/scss/Saas.scss';

// CSS
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

const App = () => {
	return (
		<ThemeProvider>
			<ConfirmProvider>
				<NotificationProvider>
					<AuthProvider>
						<AuraProvider>
							<AppRoutes />
						</AuraProvider>
					</AuthProvider>
				</NotificationProvider>
			</ConfirmProvider>
		</ThemeProvider>
	);
};

export default App;
